export const GROUP_CALENDAR_GROUP_ID = 'Groups';
